/**
 * How a pantry item's amount is stored.
 *
 * Two rules, both of which used to live inline in the `addItems` reducer and
 * are now shared with the email-import handler, which builds its documents
 * server-side and cannot dispatch:
 *
 *   - a measured amount (1.75 lb, 500 g) keeps its decimals and its unit;
 *   - a count is a whole number with no unit at all.
 *
 * "piece" and "unit" are counting pseudo-units — a row reading "2 unit" says
 * nothing "2" does not.
 */

const COUNTING_UNITS = ['piece', 'pieces', 'unit', 'units', 'unité', 'unités', 'un', 'ea'];

export interface PantryAmount {
  quantity?: number;
  unit?: string;
}

export function normalizePantryQuantity(input: {
  quantity?: number;
  unit?: string;
  quantityEstimate?: number | string;
}): PantryAmount {
  const { quantity, unit, quantityEstimate } = input;

  if (typeof quantity === 'number' && quantity > 0) {
    const isCount = !unit || COUNTING_UNITS.includes(unit.toLowerCase());
    if (!isCount) {
      return { quantity, unit };
    }
    return { quantity: Math.max(1, Math.floor(quantity)) };
  }

  if (typeof quantityEstimate === 'number' && quantityEstimate > 0) {
    return { quantity: Math.max(1, Math.floor(quantityEstimate)) };
  }

  return {};
}
